// @file handle message event from service worker

const isApiUrlForWall = (urlString: string, wallId: number): boolean => {
  const url = new URL(urlString)
  const apiWallId = url.searchParams.get('wall_id')
  return Number(apiWallId) === wallId
}

// dispatch update actions in the store based on the message event received
export const updateStoreFromSWMessage = (event: MessageEvent, wallId: number, store): void => {
  // These values should match the ones in app/javascript/packs/service_worker_cache.js
  if (
    event.origin === location.origin &&
    event.data.meta === 'sw-broadcast-update' &&
    event.data.type === 'SHOULD_UPDATE_DATA_LAYER' &&
    isApiUrlForWall(event.data.payload.updatedUrl, wallId)
  ) {
    const { cacheName, updatedUrl } = event.data.payload

    caches.open(cacheName).then((cache: Cache) => {
      cache.match(updatedUrl).then((updatedResponse: Response | undefined) => {
        if (updatedResponse === undefined) {
          return
        }
        updatedResponse.json().then(updatedJson => {
          const upperUpdatedUrl = updatedUrl.toUpperCase()
          // there is "WISH_ORDER" but since that API always return "[]", we won't do anything with it here
          if (upperUpdatedUrl.includes('WISHES')) {
            // Wish API is paginate but we only cache the first page
            const { data, meta } = updatedJson
            store.dispatch('post/fetchPostsSuccess', {
              data,
              isFirstPage: true,
              isLastPage: !meta?.next,
              shouldResetState: false,
            })
            if (meta?.next) {
              store.dispatch('post/fetchPostsForPage', {
                pageStart: meta.next,
              })
            }
          }
        })
      })
    })
  }
}
